import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { BasketProvider } from "@/context/BasketContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import OurStory from "@/pages/OurStory";
import Recipes from "@/pages/Recipes";
import RecipeDetail from "@/pages/RecipeDetail";
import WhereToBuy from "@/pages/WhereToBuy";
import Trade from "@/pages/Trade";
import Partner from "@/pages/Partner";
import Contact from "@/pages/Contact";
import { LegalPage } from "@/pages/Legal";
import TradeLogin from "@/pages/TradeLogin";
import { ForgotPassword, ResetPassword, ActivateAccount } from "@/pages/AuthPages";

import PortalDashboard from "@/pages/portal/PortalDashboard";
import PortalCatalogue from "@/pages/portal/PortalCatalogue";
import PortalBasket from "@/pages/portal/PortalBasket";
import PortalOrders from "@/pages/portal/PortalOrders";
import PortalOrderDetail from "@/pages/portal/PortalOrderDetail";
import PortalAccount from "@/pages/portal/PortalAccount";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCatalogue from "@/pages/admin/AdminCatalogue";
import AdminProductForm from "@/pages/admin/AdminProductForm";
import AdminCustomers from "@/pages/admin/AdminCustomers";
import AdminCustomerDetail from "@/pages/admin/AdminCustomerDetail";
import AdminApplications from "@/pages/admin/AdminApplications";
import AdminOrders from "@/pages/admin/AdminOrders";
import AdminOrderDetail from "@/pages/admin/AdminOrderDetail";
import AdminEnquiries from "@/pages/admin/AdminEnquiries";
import AdminEmailLog from "@/pages/admin/AdminEmailLog";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <AuthProvider>
          <BasketProvider>
            <BrowserRouter>
              <Toaster position="top-center" richColors />
              <Routes>
                {/* Public */}
                <Route path="/" element={<Home />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/our-story" element={<OurStory />} />
                <Route path="/recipes" element={<Recipes />} />
                <Route path="/recipes/:slug" element={<RecipeDetail />} />
                <Route path="/where-to-buy" element={<WhereToBuy />} />
                <Route path="/trade" element={<Trade />} />
                <Route path="/partner" element={<Partner />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<LegalPage page="privacy" />} />
                <Route path="/cookies" element={<LegalPage page="cookies" />} />
                <Route path="/terms" element={<LegalPage page="terms" />} />

                {/* Auth */}
                <Route path="/trade/login" element={<TradeLogin />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/activate" element={<ActivateAccount />} />

                {/* Trade Portal */}
                <Route path="/portal" element={<ProtectedRoute role="partner" redirect="/trade/login"><PortalDashboard /></ProtectedRoute>} />
                <Route path="/portal/catalogue" element={<ProtectedRoute role="partner" redirect="/trade/login"><PortalCatalogue /></ProtectedRoute>} />
                <Route path="/portal/basket" element={<ProtectedRoute role="partner" redirect="/trade/login"><PortalBasket /></ProtectedRoute>} />
                <Route path="/portal/orders" element={<ProtectedRoute role="partner" redirect="/trade/login"><PortalOrders /></ProtectedRoute>} />
                <Route path="/portal/orders/:id" element={<ProtectedRoute role="partner" redirect="/trade/login"><PortalOrderDetail /></ProtectedRoute>} />
                <Route path="/portal/account" element={<ProtectedRoute role="partner" redirect="/trade/login"><PortalAccount /></ProtectedRoute>} />

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminDashboard /></ProtectedRoute>} />
                <Route path="/admin/catalogue" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminCatalogue /></ProtectedRoute>} />
                <Route path="/admin/catalogue/:id" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminProductForm /></ProtectedRoute>} />
                <Route path="/admin/customers" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminCustomers /></ProtectedRoute>} />
                <Route path="/admin/customers/:id" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminCustomerDetail /></ProtectedRoute>} />
                <Route path="/admin/applications" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminApplications /></ProtectedRoute>} />
                <Route path="/admin/orders" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminOrders /></ProtectedRoute>} />
                <Route path="/admin/orders/:id" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminOrderDetail /></ProtectedRoute>} />
                <Route path="/admin/enquiries" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminEnquiries /></ProtectedRoute>} />
                <Route path="/admin/email-log" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminEmailLog /></ProtectedRoute>} />
                <Route path="/admin/settings" element={<ProtectedRoute role="admin" redirect="/admin/login"><AdminSettings /></ProtectedRoute>} />
              </Routes>
            </BrowserRouter>
          </BasketProvider>
        </AuthProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
